"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * SegmentedControl — the one view-switching control.
 * Implements surface-identity-and-shell.md §2.2 and §6 item 5.
 *
 * All view switching lives in the navy toolbar band; nothing tab-like ever sits
 * on the content background. The active segment is white-filled with a
 * --color-primary-700 label.
 *
 *   <SegmentedControl
 *     options={[{ value: 'explore', label: 'Explore' }, …]}
 *     value={tab}
 *     onChange={setTab}
 *   />
 *
 * `tone="onDark"` (the default) is the navy-band form. `tone="onLight"` uses the
 * surface tint, for the in-panel switchers (Sessions / Matrix).
 */const SegmentedControl = ({
  options = [],
  value,
  onChange,
  tone = 'onDark',
  ariaLabel,
  className = '',
  ...rest
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
  className: `segmented segmented--${tone} ${className}`.trim(),
  role: "tablist",
  "aria-label": ariaLabel,
  ...rest,
  children: options.map(opt => {
    const selected = opt.value === value;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      type: "button",
      role: "tab",
      "aria-selected": selected,
      className: `segmented__item${selected ? ' is-active' : ''}`,
      onClick: () => !selected && onChange && onChange(opt.value),
      disabled: opt.disabled,
      title: opt.title,
      children: [opt.icon && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "segmented__icon",
        children: opt.icon
      }), opt.label]
    }, opt.value);
  })
});
var _default = exports.default = SegmentedControl;